export function normalizeTime(time: string): string {
    return time.padStart(5, "0");
}
